var _a, _b, _c, _d, _e;
import { __decorate, __metadata } from "tslib";
import { translate } from 'angular';
import { Component } from 'decorators';
import { ActionType } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/Action';
import { DESK_ID_PREFIX, SUBFLOW_ID_PREFIX } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/services/BuilderStateService';
import { ActionsUpdateAndSaveState, } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components/actions/actions.dispatcher';
import { ActionsListAddAction, ActionsListDeleteItem, ActionsListOpenDetail, ActionsListUpdateAndSave, } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components/actionsList/actionsList.dispatcher';
import { AddAction } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components/addAction/addAction.dispatcher';
// Controllers
import { ExecuteScriptActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/executeScript/ExecuteScriptActionController';
import { ExecuteScriptV2ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/executeScriptV2/ExecuteScriptV2ActionController';
import { ManageListActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/manageList/ManageListActionController';
import { MergeContactActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/mergeContact/MergeContactActionController';
import { ProcessCommandActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/processCommand/ProcessCommandActionController';
import { ProcessContentAssistantActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/processContentAssistant/ProcessContentAssistantActionController';
import { ProcessHttpActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/processHttp/ProcessHttpActionController';
import { RedirectActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/redirect/RedirectActionController';
import { SetVariableActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/setVariable/SetVariableActionController';
import { TrackEventActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/trackEvent/TrackEventActionController';
import { ExecuteTemplateActionController } from '../../executeTemplate/ExecuteTemplateActionController';
// Services
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
import { BuilderTabsService } from '../../../../services/BuilderTabsService';
import { SidebarContentService, SidebarContentTypes } from 'modules/shared/SidebarContentService';
import { GLOBAL_ACTIONS } from '../../../../BuilderController';
// Views
import SetVariableActionView from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/setVariable/SetVariableActionView.html';
import ExecuteScriptActionView from '../../executeScript/ExecuteScriptActionView.html';
import ExecuteScriptV2ActionView from '../../executeScriptV2/ExecuteScriptV2ActionView.html';
import ExecuteBlipFunctionActionView from '../../executeBlipFunction/ExecuteBlipFunctionActionView.html';
import ExecuteTemplateActionView from '../../executeTemplate/ExecuteTemplateActionView.html';
import ManageListActionView from '../../manageList/ManageListActionView.html';
import MergeContactActionView from '../../mergeContact/MergeContactActionView.html';
import ProcessCommandActionView from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/processCommand/ProcessCommandActionView.html';
import ProcessContentAssistantActionView from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/processContentAssistant/ProcessContentAssistantActionView.html';
import ProcessHttpActionView from '../../processHttp/ProcessHttpActionView.html';
import RedirectActionView from '../../redirect/RedirectActionView.html';
import TrackEventActionView from '../../trackEvent/TrackEventActionView.html';
import template from './ActionsView.html';
import './Actions.scss';
import { ExecuteBlipFunctionActionController } from '../../executeBlipFunction/ExecuteBlipFunctionActionController';
import { ActionService } from '../../../../services/ActionService';
import { ActionFeatures } from '../../ActionFeatures';
import { validateActionViewModelToActionTools } from '../../../../aiAgent/utils/AgentUtils';
export const validateTab = (state) => {
    /**
     * Validate action tab
     */
    const customActionsTabElement = document.getElementById('content-tab-2');
    if (customActionsTabElement) {
        if (state.$invalidCustomActions) {
            customActionsTabElement.classList.add('invalid-background');
        }
        else {
            customActionsTabElement.classList.remove('invalid-background');
        }
    }
};
let ActionsComponent = class ActionsComponent {
    static $inject = ['SidebarContentService', 'PipelineBuilderTabsService', '$document', 'ModalService', 'PipelineBuilderSegmentService', '$translate', 'ActionService'];
    constructor(SidebarContentService, PipelineBuilderTabsService, $document, ModalService, PipelineBuilderSegmentService, $translate, ActionService) {
        'ngInject';
        this.SidebarContentService = SidebarContentService;
        this.PipelineBuilderTabsService = PipelineBuilderTabsService;
        this.$document = $document;
        this.ModalService = ModalService;
        this.PipelineBuilderSegmentService = PipelineBuilderSegmentService;
        this.$translate = $translate;
        this.ActionService = ActionService;
        this.isActionExecuteBlipFunctionEnabled = false;
    }
    $onInit() {
        this.isDeskState = this.state.id.startsWith(DESK_ID_PREFIX);
        this.isSubflowApplication = this.application?.isSubflow;
        setTimeout(() => validateTab(this.state));
        this.checkFeatures();
        this.setLimitActions();
        this.ActionService.setApplication(this.application);
    }
    async checkFeatures() {
        this.isDeskState = this.state.id.startsWith(DESK_ID_PREFIX);
        this.isSubflowState = this.state.id.startsWith(SUBFLOW_ID_PREFIX);
        this.isActionExecuteBlipFunctionEnabled = await ActionFeatures.isActionExecuteBlipFunction();
    }
    $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
        else {
            throw new Error('onAction is not implemented');
        }
    }
    setLimitActions() {
        if (this.state.$enteringCustomActions.length > 14) {
            this.enteringActionsExtras = {
                addDisabled: true,
                counter: this.getNumberOfCustomAction(true),
                counterStyle: `bp-fs-7 ${Number(this.state.$enteringCustomActions.length) > 14
                    ? 'bp-c-delete'
                    : 'bp-c-city'}`,
            };
        }
        else {
            this.enteringActionsExtras = {
                addDisabled: false,
                counter: this.getNumberOfCustomAction(true),
                counterStyle: `bp-fs-7 ${Number(this.state.$enteringCustomActions.length) > 14
                    ? 'bp-c-delete'
                    : 'bp-c-city'}`,
            };
        }
        if (this.state.$leavingCustomActions.length > 14) {
            this.leavingActionsExtras = {
                addDisabled: true,
                counter: this.getNumberOfCustomAction(false),
                counterStyle: `bp-fs-7 ${Number(this.state.$leavingCustomActions.length) > 14
                    ? 'bp-c-delete'
                    : 'bp-c-city'}`,
            };
        }
        else {
            this.leavingActionsExtras = {
                addDisabled: false,
                counter: this.getNumberOfCustomAction(false),
                counterStyle: `bp-fs-7 ${Number(this.state.$leavingCustomActions.length) > 14
                    ? 'bp-c-delete'
                    : 'bp-c-city'}`,
            };
        }
    }
    trackUrlDocumentInputAction(property) {
        this.trackClickDocumentUrlActions(property);
    }
    getNumberOfCustomAction(isEnteringAction) {
        if (isEnteringAction) {
            return `${(this.isSubflowState ? this.state.$enteringCustomActions.length - 3 : this.state.$enteringCustomActions.length)}/15`;
        }
        else {
            return `${this.state.$leavingCustomActions.length}/15`;
        }
    }
    /**
     * Dispatch update and save action
     */
    async onUpdateAndSaveState() {
        const action = new ActionsUpdateAndSaveState();
        await this.$dispatch(action);
        validateTab(this.state);
    }
    /**
     * Add entering action
     */
    onAddEnteringAction(action) {
        switch (action.constructor) {
            case AddAction:
                const { action: enteringAction } = action;
                this.state.$enteringCustomActions = this.state.$enteringCustomActions.concat(enteringAction);
                this.afterActionAdded(enteringAction, 'Entering', true);
                this.setLimitActions();
                break;
            default:
                throw new Error(`Unrecognized dispatched action: ${action}`);
        }
    }
    /**
     * Add leaving action
     */
    onAddLeavingAction(action) {
        switch (action.constructor) {
            case AddAction:
                const { action: leavingAction } = action;
                this.state.$leavingCustomActions = this.state.$leavingCustomActions.concat(leavingAction);
                this.afterActionAdded(leavingAction, 'Leaving', true);
                this.setLimitActions();
                break;
            default:
                throw new Error(`Unrecognized dispatched action: ${action}`);
        }
    }
    onAddLocalCustomAction(action) {
        switch (action.constructor) {
            case AddAction:
                const { action: localAction } = action;
                this.state.$localCustomActions = this.state.$localCustomActions.concat(localAction);
                this.afterActionAdded(localAction, 'Local', true);
                this.setLimitActions();
                break;
            default:
                throw new Error(`Unrecognized dispatched action: ${action}`);
        }
    }
    /**
     * Entering actions-list action
     */
    async onEnteringActionsListAction(action) {
        switch (action.constructor) {
            case ActionsListDeleteItem:
                const { action: deleteItemEnteringAction } = action;
                this.state.$enteringCustomActions = this.state.$enteringCustomActions.filter((a) => a != deleteItemEnteringAction);
                await this.onUpdateAndSaveState();
                this.afterActionDeleted(deleteItemEnteringAction, 'Entering', this.state.id === GLOBAL_ACTIONS);
                break;
            case ActionsListOpenDetail:
                const { action: openDetailEnteringAction } = action;
                await this.openActionDetail(openDetailEnteringAction, true);
                break;
            case ActionsListUpdateAndSave:
                this.afterActionUpdated('Entering');
                break;
            case ActionsListAddAction:
                const { action: enteringAction } = action;
                this.state.$enteringCustomActions = this.state.$enteringCustomActions.concat(enteringAction);
                this.afterActionAdded(enteringAction, 'Entering', false);
                this.setLimitActions();
                break;
            default:
                throw new Error(`Unrecognized dispatched action: ${action}`);
        }
        this.setLimitActions();
    }
    /**
     * Leaving actions-list action
     */
    async onLeavingActionsListAction(action) {
        switch (action.constructor) {
            case ActionsListDeleteItem:
                const { action: deleteItemLeavingAction } = action;
                this.state.$leavingCustomActions = this.state.$leavingCustomActions.filter((a) => a != deleteItemLeavingAction);
                await this.onUpdateAndSaveState();
                this.afterActionDeleted(deleteItemLeavingAction, 'Leaving', this.state.id === GLOBAL_ACTIONS);
                break;
            case ActionsListOpenDetail:
                const { action: openDetailLeavingAction } = action;
                await this.openActionDetail(openDetailLeavingAction, false);
                break;
            case ActionsListUpdateAndSave:
                this.afterActionUpdated('Leaving');
                break;
            case ActionsListAddAction:
                const { action: leavingAction } = action;
                this.state.$leavingCustomActions = this.state.$leavingCustomActions.concat(leavingAction);
                this.afterActionAdded(leavingAction, 'Leaving', false);
                this.setLimitActions();
                break;
            default:
                throw new Error(`Unrecognized dispatched action: ${action}`);
        }
        this.setLimitActions();
    }
    async onLocalCustomActionsListAction(action) {
        switch (action.constructor) {
            case ActionsListDeleteItem:
                const { action: deleteItemLocalAction } = action;
                this.state.$localCustomActions = this.state.$localCustomActions.filter((a) => a != deleteItemLocalAction);
                await this.onUpdateAndSaveState();
                this.afterActionDeleted(deleteItemLocalAction, 'Local');
                break;
            case ActionsListOpenDetail:
                const { action: openDetailLocalAction } = action;
                await this.openActionDetail(openDetailLocalAction, false);
                break;
            case ActionsListUpdateAndSave:
                this.afterActionUpdated('Local');
                break;
            case ActionsListAddAction:
                const { action: localAction } = action;
                this.state.$localCustomActions = this.state.$localCustomActions.concat(localAction);
                this.afterActionAdded(localAction, 'Local', false);
                this.setLimitActions();
                break;
            default:
                throw new Error(`Unrecognized dispatched action: ${action}`);
        }
        this.setLimitActions();
    }
    /**
    * Called after any actions updated
    */
    afterActionUpdated(time) {
        this.trackBlockActionPositionChanged(time);
    }
    /**
     * Called after any actions added
     */
    async afterActionAdded(action, time, openDetail) {
        const isEnteringAction = time === 'Entering';
        this.trackBlockActionAdded(time, action.type, this.state.id === GLOBAL_ACTIONS);
        await this.onUpdateAndSaveState();
        if (openDetail === true) {
            await this.openActionDetail(action, isEnteringAction);
        }
        if (action.type === 'SetVariable') {
            this.trackAction();
        }
    }
    afterActionDeleted(action, time, isGlobalAction) {
        this.trackBlockActionDeleted(time, action.type, isGlobalAction);
    }
    /**
     * Open action detail sidebar
     */
    async openActionDetail(action, isEnteringAction) {
        this.isEnteringAction = isEnteringAction ? 'Entering' : 'Leaving';
        this.currentAction = action;
        if (!action) {
            return;
        }
        const getActionTypeConfigs = (type) => {
            switch (type) {
                case ActionType.ProcessHttp:
                    return {
                        controller: ProcessHttpActionController,
                        template: ProcessHttpActionView,
                    };
                case ActionType.MergeContact:
                    return {
                        controller: MergeContactActionController,
                        template: MergeContactActionView,
                    };
                case ActionType.Redirect:
                    return {
                        controller: RedirectActionController,
                        template: RedirectActionView,
                    };
                case ActionType.TrackEvent:
                    return {
                        controller: TrackEventActionController,
                        template: TrackEventActionView,
                    };
                case ActionType.ManageList:
                    return {
                        controller: ManageListActionController,
                        template: ManageListActionView,
                    };
                case ActionType.ExecuteScript:
                    return {
                        controller: ExecuteScriptActionController,
                        template: ExecuteScriptActionView,
                    };
                case ActionType.ExecuteScriptV2:
                    return {
                        controller: ExecuteScriptV2ActionController,
                        template: ExecuteScriptV2ActionView,
                    };
                case ActionType.ExecuteBlipFunction:
                    return {
                        controller: ExecuteBlipFunctionActionController,
                        template: ExecuteBlipFunctionActionView,
                    };
                case ActionType.ExecuteTemplate:
                    return {
                        controller: ExecuteTemplateActionController,
                        template: ExecuteTemplateActionView,
                    };
                case ActionType.SetVariable:
                    return {
                        controller: SetVariableActionController,
                        template: SetVariableActionView,
                    };
                case ActionType.ProcessContentAssistant:
                    return {
                        controller: ProcessContentAssistantActionController,
                        template: ProcessContentAssistantActionView,
                    };
                case ActionType.ProcessCommand:
                    return {
                        controller: ProcessCommandActionController,
                        template: ProcessCommandActionView,
                    };
                default:
                    throw Error(`Unknown action type '${action}'`);
            }
        };
        const actionTypeConfigs = getActionTypeConfigs(action.type);
        const sidenav = await this.SidebarContentService.showSidebar({
            ...actionTypeConfigs,
            controllerAs: '$ctrl',
            appendToElement: this.$document[0].getElementById('sidebar-detail-actions-content'),
            allowMultiple: true,
            inputs: {
                action,
                $onStateChanged: async (action) => {
                    this.onUpdateAndSaveState();
                },
                $document: this.$document,
                ModalService: this.ModalService,
                SidebarContentService: this.SidebarContentService,
                state: this.state,
                typeOfAction: this.isEnteringAction,
                onOpenSchemaEditor: (action) => this.onOpenSchemaEditor({ $action: action }),
                onActionBlur: async (action) => {
                    const { validTitle, isUniqueTitle } = validateActionViewModelToActionTools(action, this.state);
                    if (validTitle && isUniqueTitle) {
                        this.onSaveActionSchema({ $action: action });
                    }
                },
            },
            type: SidebarContentTypes.BuilderActionSidebar,
        });
        this.PipelineBuilderTabsService.addSidebar(sidenav);
        document.getElementById('node-content-tab').scrollTop = 0;
        await sidenav.closeDeferred.promise;
    }
    // Segment
    trackAction() {
        this.PipelineBuilderSegmentService.trackAction({ action: 'SetVariable' });
    }
    trackBlockActionAdded(ActionTime, ActionType, isGlobalAction) {
        this.PipelineBuilderSegmentService.trackBlockActionAdded({
            ActionTime,
            ActionType,
            BlockID: this.state.id,
        }, true, isGlobalAction);
    }
    trackBlockActionDeleted(ActionTime, ActionType, isGlobalAction) {
        this.PipelineBuilderSegmentService.trackBlockActionDeleted({
            ActionTime,
            ActionType,
            BlockID: this.state.id,
        }, true, isGlobalAction);
    }
    trackBlockActionPositionChanged(actionTime) {
        this.PipelineBuilderSegmentService.trackBlockActionPositionChanged({
            ActionTime: actionTime,
            BlockID: this.state.id,
        }, true);
    }
    trackClickDocumentUrlActions(property) {
        this.PipelineBuilderSegmentService.trackClickDocumentUrl({
            LinkName: property,
        }, true);
    }
};
ActionsComponent.$inject = ['SidebarContentService', 'PipelineBuilderTabsService', '$document', 'ModalService', 'PipelineBuilderSegmentService', '$translate', 'ActionService'];
ActionsComponent = __decorate([
    Component({
        template,
        bindings: {
            state: '=',
            application: '<',
            onAction: '&',
            type: '&',
            onOpenActionModal: '&',
            onOpenSchemaEditor: '&',
            onSaveActionSchema: '&',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof SidebarContentService !== "undefined" && SidebarContentService) === "function" ? _a : Object, typeof (_b = typeof BuilderTabsService !== "undefined" && BuilderTabsService) === "function" ? _b : Object, Object, Object, typeof (_c = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _c : Object, typeof (_d = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _d : Object, typeof (_e = typeof ActionService !== "undefined" && ActionService) === "function" ? _e : Object])
], ActionsComponent);
export { ActionsComponent };
